import React from 'react';
import { Col, Row, Tabs } from 'antd';
import { List, Apple, LayoutTemplate } from 'lucide-react';
import FoodsList from 'pages/foods/foods-list';
import DietPlanTemplateList from 'pages/diet-plan-template/diet-plan-template-list';
import DietPlanListFunctional from './components/diet-plan-list-functional';
import { useI18n } from '../../../hooks/useI18n';

const DietPlanList = () => {
	const { t } = useI18n();
	const tabItems = [
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<List size={16} />
					{t('navigation.diet_plan')}
				</span>
			),
			key: 'DIET_PLAN',
			children: <DietPlanListFunctional />,
		},
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<Apple size={16} />
					{t('navigation.foods')}
				</span>
			),
			key: 'FOODS',
			children: <FoodsList />,
		},
		{
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<LayoutTemplate size={16} />
					{t('diet_plan_template.title')}
				</span>
			),
			key: 'DIET_PLAN_TEMPLATE',
			children: <DietPlanTemplateList />,
		},
	];

	return (
		<Row className="personal-training-tab-container">
			<Col xl={24} className="container">
				<Tabs defaultActiveKey="DIET_PLAN" items={tabItems} destroyInactiveTabPane />
			</Col>
		</Row>
	);
};

export default DietPlanList;
